import React, { useRef, useState } from 'react'
import { Search } from 'semantic-ui-react'

import CardService from 'services/card.service'

import { useActions } from 'redux/hooks'
import { toggleTextOff as toggleTextOffAction, toggleTextOn as toggleTextOnAction } from 'redux/active/actions'

import styles from './toolbar.module.scss'

type Props = {
  toolbarId: string
  getQuill: Function
  promptImage: Function
}

/**
 * This is the toolar for the @see RichTextEditor it controls stuff like
 * - Bold
 * - Italics
 * - Adding cards
 * - bullets
 * - etc
 */
const Toolbar = ({ toolbarId, getQuill, promptImage }: Props) => {
  const searchInput = useRef<HTMLInputElement>()

  const [searchValue, setSearchValue] = useState('')

  const [toggleTextOff, toggleTextOn] = useActions(toggleTextOffAction, toggleTextOnAction)

  const [autocompleteResults, setAutocompleteResults] = useState<string[]>([])

  const handleSearchChange = async (_event: any, value: any) => {
    setSearchValue(value.value)
    if (value.value.length > 2) {
      const results = await CardService.autocomplete(value.value)
      setAutocompleteResults(results)
    } else setAutocompleteResults([])
  }

  /**
   * Handles what is selected from the card search results
   */
  const handleResultSelect = (_event: any, data: Record<string, any>) => {
    setSearchValue('')
    setAutocompleteResults([])

    const quill = getQuill()
    quill.focus()
    const position = quill.getSelection().index
    quill.insertEmbed(position, 'card-link', data.result.title)
    quill.insertText(position + 1, ' ')
    quill.setSelection(position + 2)
  }

  return (
    <div className={styles.toolbarContainer} id={toolbarId}>
      <select className="ql-header" />

      <div className={styles.spaced} />

      <button className="ql-bold" />
      <button className="ql-italic" />
      <button className="ql-underline" />

      <div className={styles.spaced} />

      <button className="ql-strike" />
      <button className="ql-blockquote" />

      <div className={styles.spaced} />

      <button className="ql-list" value="ordered" />
      <button className="ql-list" value="bullet" />

      <div className={styles.spaced} />

      <select className="ql-color" />
      <select className="ql-background" />

      <div className={styles.spaced} />

      <button className="ql-link" />
      <button className="ql-image" onClick={() => promptImage()} />
      <button className="ql-video" />

      <Search
        style={{ flex: '1 1 50px', display: 'flex', padding: 0 }}
        onResultSelect={handleResultSelect}
        onSearchChange={handleSearchChange}
        noResultsMessage={'There are no cards with that name.'}
        minCharacters={3}
        results={autocompleteResults.map(name => ({ title: name }))}
        value={searchValue}
        input={{
          ref: (box: HTMLInputElement) => {
            searchInput.current = box
          },
          style: { width: 200, height: 25, paddingTop: 0 },
          placeholder: 'Add card to comment...',
        }}
        icon=""
        onFocus={() => toggleTextOn()}
        onBlur={() => toggleTextOff()}
      />
    </div>
  )
}

export default Toolbar
